import {tv, type VariantProps} from 'tailwind-variants'

const bankSwatchVariants = tv({
  base: 'h-12 w-12 shrink-0 rounded',
  variants: {
    color: {
      beige: 'bg-beige-base-500',
      primary: 'bg-surface-primary',
    },
  },
})

export type BankSwatchProps = {
  color: NonNullable<VariantProps<typeof bankSwatchVariants>['color']>
}

const BankSwatch = ({color}: BankSwatchProps) => {
  return <span className={bankSwatchVariants({color})} aria-hidden={true} />
}

export default BankSwatch
